export default __webpack_public_path__ + "static/media/qatar-airways.0b0dde46.jpg";